
























import Vue from 'vue'

import moment from "moment"
import { DealStatus } from '@/api/dto/DealStatus'
import { defaultIconUrl } from '@/properties';
import { getColorClass } from '@/utils/styleUtils';

export default Vue.extend({
  name: 'ReviewCard',
  props: {
    deals: Array,
    tagShow: Boolean,
  },
  data() {
    return {
      defaultIconUrl,
    }
  },
  methods: {
    setColorClass(lang: string) {
      return getColorClass(lang);
    },
  },
  filters: {
    amountLocaleString: function(amount: number) {
      return amount.toLocaleString();
    },
    formatDate: function(date: Date, fmt: string) {
      return moment(date).format(fmt);
    },
    timeDiff: function(date: Date){
      moment.locale('ja');
      return moment(date).fromNow();
    },
    status: function(dealStatus: DealStatus): string {
      return ['期限切れ', '受注待ち', 'レビュー中', '確認中', '完了'][dealStatus] ?? '';
    }
  },
})
